@if (layout === 'empty') {
  <empty-layout class=" h-full"></empty-layout>
}
@if (layout === 'centered') {
  <centered-layout></centered-layout>
}
@if (layout === 'enterprise') {
  <enterprise-layout></enterprise-layout>
}
@if (layout === 'material') {
  <material-layout></material-layout>
}
@if (layout === 'modern') {
  <modern-layout></modern-layout>
}
@if (layout === 'classic') {
  <classic-layout></classic-layout>
}
@if (layout === 'classy') {
  <classy-layout></classy-layout>
}
@if (layout === 'compact') {
  <compact-layout></compact-layout>
}
@if (layout === 'dense') {
  <dense-layout></dense-layout>
}
@if (layout === 'futuristic') {
  <futuristic-layout></futuristic-layout>
}
@if (layout === 'thin') {
  <thin-layout></thin-layout>
}
